export default "__VITE_PUBLIC_ASSET__b15a4178__"